import React, { lazy } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { BodyWrapper, Fallback, Layout, Logout } from '../components'

const ChatsManagement = lazy(async () => await import('@web/modules/chats-management/ui/ChatsManagement'))
const DefaultMessages = lazy(async () => await import('@web/modules/managements/default-messages/ui/DefaultMessages'))
const Dashboard = lazy(async () => await import('@web/modules/dashboard/ui/Dashboard'))
const MessagesManagement = lazy(async () => await import('@web/modules/messages-management/ui/MessagesManagement'))
const TransferChat = lazy(async () => await import('@web/modules/transfer-chat/ui/TransferChat'))
const DefaultMessagesForm = lazy(
  async () => await import('@web/modules/managements/default-messages/ui/DefaultMessagesForm')
)
const DefaultMessagesUse = lazy(
  async () => await import('@web/modules/managements/default-messages/ui/DefaultMessagesUse')
)
const NewChat = lazy(async () => await import('@web/modules/new-chat/ui/NewChat'))
const NotFound = lazy(async () => await import('@web/modules/not-found/ui/NotFound'))
const ArchiveChat = lazy(async () => await import('@web/modules/archive-chat/ui/ArchiveChat'))
const BlockContact = lazy(async () => await import('@web/modules/block-contact/ui/BlockContact'))
const ClientManagement = lazy(async () => await import('@web/modules/client-management/ui/ClientManagement'))
const UserguidingRoute = lazy(async () => await import('@web/modules/userguiding/ui/UserguidingRoute'))
const SendFlowMessage = lazy(async () => await import('@web/modules/send-flow-message/ui/SendFlowMessage'))
const Tags = lazy(async () => await import('@web/modules/managements/tags/ui/Tags'))
const TagsForm = lazy(async () => await import('@web/modules/managements/tags/ui/TagsForm'))
const TagsUse = lazy(async () => await import('@web/modules/managements/tags/ui/TagsUse'))

const Router = () => (
  <BrowserRouter>
    <React.Suspense fallback={<Fallback />}>
      <Routes>
        <Route element={<Layout />}>
          {['/', 'chats'].map(path => (
            <Route
              element={<ChatsManagement />}
              path={path}
              key={path}
            >
              <Route
                path={':chatKey/:chatId'}
                element={
                  <React.Suspense>
                    <MessagesManagement />
                  </React.Suspense>
                }
              >
                <Route
                  path={'transferChat'}
                  element={
                    <React.Suspense>
                      <TransferChat />
                    </React.Suspense>
                  }
                />
                <Route
                  path={'defaultMessages'}
                  element={
                    <React.Suspense>
                      <DefaultMessagesUse />
                    </React.Suspense>
                  }
                >
                  <Route
                    path={'form'}
                    element={
                      <React.Suspense fallback={<Fallback />}>
                        <DefaultMessagesForm />
                      </React.Suspense>
                    }
                  />
                </Route>
                <Route
                  path={'tags'}
                  element={
                    <React.Suspense>
                      <TagsUse />
                    </React.Suspense>
                  }
                >
                  <Route
                    path={'form'}
                    element={
                      <React.Suspense fallback={<Fallback />}>
                        <TagsForm />
                      </React.Suspense>
                    }
                  />
                </Route>
                <Route
                  path={'sendFlow'}
                  element={
                    <React.Suspense>
                      <SendFlowMessage />
                    </React.Suspense>
                  }
                />
                <Route
                  path={'transferChat'}
                  element={
                    <React.Suspense>
                      <TransferChat />
                    </React.Suspense>
                  }
                />
                <Route
                  path={'newChat'}
                  element={
                    <React.Suspense>
                      <NewChat />
                    </React.Suspense>
                  }
                />
                <Route
                  path={'archiveChat'}
                  element={
                    <React.Suspense>
                      <ArchiveChat />
                    </React.Suspense>
                  }
                />
                <Route
                  path={'blockContact'}
                  element={
                    <React.Suspense>
                      <BlockContact />
                    </React.Suspense>
                  }
                />
                <Route
                  path={'clientManagement'}
                  element={
                    <React.Suspense>
                      <ClientManagement />
                    </React.Suspense>
                  }
                />
                <Route
                  path={'guide/:profile'}
                  element={
                    <React.Suspense fallback={<Fallback />}>
                      <BodyWrapper>
                        <UserguidingRoute />
                      </BodyWrapper>
                    </React.Suspense>
                  }
                />
              </Route>
              <Route
                path={'transferChat'}
                element={
                  <React.Suspense>
                    <TransferChat />
                  </React.Suspense>
                }
              />
              <Route
                path={'newChat'}
                element={
                  <React.Suspense>
                    <NewChat />
                  </React.Suspense>
                }
              />
              <Route
                path={'archiveChat'}
                element={
                  <React.Suspense>
                    <ArchiveChat />
                  </React.Suspense>
                }
              />
              <Route
                path={'blockContact'}
                element={
                  <React.Suspense>
                    <BlockContact />
                  </React.Suspense>
                }
              />
              <Route
                path={'clientManagement'}
                element={
                  <React.Suspense>
                    <ClientManagement />
                  </React.Suspense>
                }
              />
            </Route>
          ))}
        </Route>
        <Route
          element={<Layout />}
          path={'defaultMessages'}
        >
          <Route
            path={''}
            element={
              <React.Suspense fallback={<Fallback />}>
                <BodyWrapper>
                  <DefaultMessages />
                </BodyWrapper>
              </React.Suspense>
            }
          >
            <Route
              path={'form'}
              element={
                <React.Suspense fallback={<Fallback />}>
                  <DefaultMessagesForm />
                </React.Suspense>
              }
            />
          </Route>
        </Route>
        <Route
          element={<Layout />}
          path={'Tags'}
        >
          <Route
            path={''}
            element={
              <React.Suspense fallback={<Fallback />}>
                <BodyWrapper>
                  <Tags />
                </BodyWrapper>
              </React.Suspense>
            }
          >
            <Route
              path={'form'}
              element={
                <React.Suspense fallback={<Fallback />}>
                  <TagsForm />
                </React.Suspense>
              }
            />
          </Route>
        </Route>
        <Route
          element={<Layout />}
          path={'/dashboard'}
        >
          <Route
            path={''}
            element={
              <React.Suspense fallback={<Fallback />}>
                <BodyWrapper>
                  <Dashboard />
                </BodyWrapper>
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={<Layout />}
          path={'guide/:profile'}
        >
          <Route
            path={''}
            element={
              <React.Suspense fallback={<Fallback />}>
                <BodyWrapper>
                  <UserguidingRoute />
                </BodyWrapper>
              </React.Suspense>
            }
          />
        </Route>
        <Route
          path='/chats/:phoneNumber'
          element={<ChatsManagement />}
        >
          <Route
            path={'guide/:profile'}
            element={
              <React.Suspense fallback={<Fallback />}>
                <BodyWrapper>
                  <UserguidingRoute />
                </BodyWrapper>
              </React.Suspense>
            }
          />
        </Route>
        <Route
          path='/:phoneNumber'
          element={<ChatsManagement />}
        />
        <Route
          path={'/404'}
          element={<Layout />}
        >
          <Route
            path=''
            element={
              <React.Suspense fallback={<Fallback />}>
                <BodyWrapper>
                  <NotFound />
                </BodyWrapper>
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={<Logout />}
          path={'/logout'}
        />
        <Route
          path='*'
          element={
            <Navigate
              replace
              to='/404'
            />
          }
        />
      </Routes>
    </React.Suspense>
  </BrowserRouter>
)

export default Router
